const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/defs.ts';
const VersionJson = require('../../version.json');

console.log(`Version is ${JSON.stringify(VersionJson)}`);

export const [VERSION, VERSION_SUB] = (() => {
    const version = VersionJson['version'] || 'No Version Specified';
    const versionData = version.split(/[ _-]/);
    const addInfo = process.env.NODE_ENV !== 'production' ? ' (DEV)' : '';
    if (versionData.length < 2) {
        return [versionData, addInfo];
    }
    versionData[1] = `${versionData[1]}${addInfo || ''}`;
    return versionData;
})();
